import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.mainElement = document.querySelector('main')

    if (this.mainElement) {
      this.syncHeight()
      this.setupResizeObserver()
      this.setupStreamListener()
    }
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
    if (this.streamListener) {
      document.removeEventListener('turbo:before-stream-render', this.streamListener)
    }
  }

  syncHeight = () => {
    const height = this.mainElement.offsetHeight
    this.element.style.height = `${height}px`
  }

  setupResizeObserver = () => {
    this.resizeObserver = new ResizeObserver(() => {
      this.syncHeight()
    })
    this.resizeObserver.observe(this.mainElement)
  }

  setupStreamListener = () => {
    this.streamListener = (event) => {
      const originalRender = event.detail.render
      event.detail.render = async (currentElement) => {
        await originalRender(currentElement)
        this.syncHeight()
      }
    }
    document.addEventListener('turbo:before-stream-render', this.streamListener)
  }
}
